module.exports = __webpack_public_path__ + "static/media/fb.cc807c65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fb.svg
// module id = 275
// module chunks = 0